import {
  ActivationStatus,
  Address,
  DeliveryAddress,
  Plan,
  PostActivationStatus,
  SignUpStatus,
  Status,
} from '@smarty-nx/data'
import { MAX_ACTIVE_GROUP_MEMBERS_NUMBER } from '../constants'

export const getDeliveryAddressTitle = (
  index: number,
  total?: number,
  is_owner?: boolean
): string => {
  return (is_owner !== undefined && is_owner) ||
    !total ||
    (total && index === 0)
    ? 'Your address'
    : `Address ${index + 1}`
}

export const sortAddressesByOwner = (
  addresses: DeliveryAddress[]
): DeliveryAddress[] => {
  const sorted = addresses.reduce(
    (acc: [DeliveryAddress[], DeliveryAddress[]], current: DeliveryAddress) => {
      if (current.is_owner) acc[0].push(current)
      else acc[1].push(current)
      return acc
    },
    [[], []] as [DeliveryAddress[], DeliveryAddress[]]
  )
  return [...sorted[0], ...sorted[1]]
}

export const getAddressLabel = ({
  street_1,
  street_2,
  postal_code,
  town,
  country,
  company,
}: Address) =>
  [street_1, street_2, company, town, country, postal_code]
    .filter((field) => !!field)
    .join(', ')

export const getFamilyPlanPrice = (
  plan: Plan,
  membersNumber: number
): number => {
  return (
    plan.finalPrice?.value +
    getFamilyAdditionalMembersPrice(plan, membersNumber - 1)
  )
}

export const getFamilyAdditionalMembersPrice = (
  plan: Plan,
  membersNumber: number
) => {
  return membersNumber * Number(plan?.additionalSims?.value)
}

const PreActivationStatuses = [
  ActivationStatus.ACTIVATE_SIM,
  ActivationStatus.ACTIVATION_FAILED,
  ActivationStatus.ACTIVATION_REQUESTED,
  ActivationStatus.AWAITING_ACTIVATION,
  SignUpStatus.SETUP,
  SignUpStatus.INVITATION_SENT,
  SignUpStatus.INVITATION_ACCEPTED,
] as const

export function isPreActivationStatus(
  status: string
): status is (typeof PreActivationStatuses)[number] {
  return PreActivationStatuses.some((s) => status === s)
}

export function isOwnerAllowedToAddMember(
  membersCount: number,
  ownerStatus: Status
): boolean {
  const statusesAllowedToShowAddMember = [
    ActivationStatus.ACTIVATE_SIM,
    PostActivationStatus.ACTIVE,
  ]

  return (
    membersCount < MAX_ACTIVE_GROUP_MEMBERS_NUMBER &&
    statusesAllowedToShowAddMember.includes(
      ownerStatus as PostActivationStatus | ActivationStatus
    )
  )
}
